import * as Sentry from "@sentry/react"
import React from "react"
import ReactDom from "react-dom/client"

import "@/utils/sentry"
import "@/utils/websdk"

import App from "./App"
import Layout from "./layout"

import "@/styles/global.scss"
import "@hg/scroll/lib/index.css"

const Root: React.FC = () => {
    return (
        <Sentry.ErrorBoundary>
            <Layout>
                <App />
            </Layout>
        </Sentry.ErrorBoundary>
    )
}

const container = document.getElementById("root")
if (container) {
    const root = ReactDom.createRoot(container)
    root.render(<Root />)
}
